import { action, runInAction, observable } from 'mobx';
import { ErrorInterface } from 'modules/core/api/globalApi';
import cloneDeep from 'lodash/cloneDeep';
// import isEqual from 'lodash/isEqual';
import partnerController from '../controller';
import {
  DocTemplate,
  DocTemplatesRequest,
  CreateDocTemplateREquest,
  UpdateDocTemplateREquest,
} from './partnerTemplateApi.d';

export interface PartnerTemplateStore {
  docTemplates: DocTemplate[],
  docTemplatesRequest: DocTemplatesRequest,
  currentDocTemplates: DocTemplate,
  docTemplateFonts: string[], // список установленных на сервере шрифтов

  error: ErrorInterface,
}

const initialValues: PartnerTemplateStore = {
  docTemplates: [],
  docTemplatesRequest: null,
  currentDocTemplates: null,
  docTemplateFonts: [],
  error: null,
};

export const partnerTemplateStore = observable(initialValues);

export const partnerTemplateActions = {

  async getDocTemplates(request :DocTemplatesRequest) {
    partnerTemplateActions.clearError();
    // reconciliationActions.setLoading();
    runInAction(() => {
      partnerTemplateStore.docTemplatesRequest = { ...request };
    });
    const response = await partnerController.getDocTemplates(request);
    partnerTemplateActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        partnerTemplateStore.docTemplates = response.data?.items ?? [];
      }
    });
  },

  handleError: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      partnerTemplateStore.error = {
        message: errorData?.message,
        errorCode: errorData?.errorCode,
        timestamp: errorData?.timestamp,
        status: response?.status,
        connectError: response?.connectError,
        isError: response?.error,
      };
      throw errorData;
    }
  }),

  clearDocTemplates: action(() => {
    partnerTemplateStore.docTemplatesRequest = null;
    partnerTemplateStore.docTemplates = [];
  }),

  async clearError() {
    partnerTemplateStore.error = null;
  },

  createDocTemplates: async (request: CreateDocTemplateREquest): Promise<void> => {
    partnerTemplateActions.clearError();
    const response = await partnerController.createDocTemplates({
      ...request,
      wheelsWidthDiffer: request?.wheelsWidthDiffer ?? false,
    });
    partnerTemplateActions.handleError(response);
    if (!response.errorData) {
      const x = cloneDeep(partnerTemplateStore.docTemplates);
      x.push(response.data);
      runInAction(() => {
        partnerTemplateStore.docTemplates = cloneDeep(x);
      });
    }
  },

  updateDocTemplates: async (request: UpdateDocTemplateREquest): Promise<void> => {
    partnerTemplateActions.clearError();
    const response = await partnerController.updateDocTemplates({
      ...request,
      wheelsWidthDiffer: request?.wheelsWidthDiffer ?? false,
    });
    partnerTemplateActions.handleError(response);
    if (!response.errorData) {
      const x = partnerTemplateStore.docTemplates.filter((v) => v.id !== request.id);
      x.push(response.data);
      runInAction(() => {
        partnerTemplateStore.docTemplates = cloneDeep(x);
      });
    }
  },

  deleteDocTemplates: async (id: string): Promise<void> => {
    if (partnerTemplateStore.error) { partnerTemplateActions.clearError(); }
    const response = await partnerController.deleteDocTemplates(id);
    partnerTemplateActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        partnerTemplateStore.docTemplates.find((v) => v.id !== id).deletedDate = 'Удалено';
      }
    });
  },

  restoreDocTemplates: async (id: string): Promise<void> => {
    if (partnerTemplateStore.error) { partnerTemplateActions.clearError(); }
    const response = await partnerController.restoreDocTemplates(id);
    partnerTemplateActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        partnerTemplateStore.docTemplates.find((v) => v.id !== id).deletedDate = null;
      }
    });
  },

  setCurrentDocTemplates: action((docTemplate: DocTemplate) => {

    partnerTemplateStore.currentDocTemplates = docTemplate;
  }),

  clearCurrentDocTemplates: action(() => {

    partnerTemplateStore.currentDocTemplates = null;
  }),

  // получить байты файла шаблона через бэк-прокси (обходим CORS приватного S3)
  async fetchDocTemplateFile(id: string): Promise<ArrayBuffer | null> {
    const response = await partnerController.getDocTemplateFile(id);
    return response?.errorData ? null : (response?.data ?? null);
  },

  async getDocTemplateFonts() {
    partnerTemplateActions.clearError();
    const response = await partnerController.getDocTemplateFonts();
    partnerTemplateActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        partnerTemplateStore.docTemplateFonts = response.data?.items ?? [];
      }
    });
  },

};
